import { HttpClient } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { Subject, Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { DialogService } from 'src/app/utils/services/dialog.service';
import { environment } from 'src/environments/environment';
import { TypeImageService } from './type-image.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { AddTypeImageAdminComponent } from './add-type-image-admin/add-type-image-admin.component';
import { EditTypeImageAdminComponent } from './edit-type-image-admin/edit-type-image-admin.component';

import { helper } from 'src/environments/helper';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
    selector: 'app-type-image-admin',
    templateUrl: './type-image-admin.component.html',
    styleUrls: ['./type-image-admin.component.scss'],
})
export class TypeImageAdminComponent {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;

    isLoading = false;
    showCard = false;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink =
        environment.interop.basePath +
        environment.interop.platform.nomenclatoare.imageType.getImageTypesDT;

    parameters: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Da', value: '1' },
        { key: 'Nu', value: '0' },
    ];

    toggleCard() {
        this.showCard = !this.showCard;
    }

    onSelectionChange(event: any): void {
        // this.activeValue = event.target.value;
        // this.publicValue = event.target.value;
    }

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private typeImageService: TypeImageService,
        public permissionsService: PermissionsService,
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            pagingType: 'full_numbers',
            serverSide: true,
            // processing: true,
            responsive: true,
            searching: false,
            pageLength: 25,
            lengthMenu: [10, 25, 50, 100],
            language: environment.config.romanianLanguageDataTable,
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                },
                {
                    title: 'Denumire',
                    data: 'name',
                },
                {
                    title: 'Lățime',
                    data: 'width',
                },
                {
                    title: 'Înălțime',
                    data: 'height',
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    className: 'all',
                    orderable: false,
                    render: () => {
                        return `
            <div class="d-flex align-center justify-content-left">
							<button class="action-btn edit ms-1">
								<img class="btn-img" src="/assets/icons/edit.svg" alt="edit"/>
							</button>
							<button type="button" class="action-btn delete ms-1">
							<img class="btn-img" src="/assets/icons/delete.svg" alt="delete"/>
						</button>
            </div>
            		`;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd ?.querySelector('.edit') as HTMLElement;
                const deleteIcon = lastTd ?.querySelector('.delete') as HTMLElement;

                if (editIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.administrative.image-types.update'
                        )
                    ) {
                        editIcon.style.display = 'none';
                    }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                if (deleteIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.administrative.image-types.update'
                        )
                    ) {
                        deleteIcon.style.display = 'none';
                    }
                    deleteIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.delete(id);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(paging: boolean = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            // Destroy the table first
            // dtInstance.destroy();
            // Call the dtTrigger to rerender again
            // this.dtTrigger.next('');
            dtInstance.draw(paging);
        });
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddTypeImageAdminComponent, {
            ...this.dialogService.getDialogConfig(),
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Tip Imagine adaugată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openEditDialog(data: any) {
        const dialogRef = this.dialog.open(EditTypeImageAdminComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Tip imagine actualizată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    delete(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Nu o să puteți recupera datele odată cu ștergerea lor!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                // we do this because we need to have some control on activity
                this.deleteAction(id);
            }
        });
    }

    deleteAction(id: number) {
        this.isLoading = true;
        this.typeImageService.deleteImageType(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Dimensiune imagine ștearsă cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }

                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.deleteAction(id);
                    }
                });
            }
        );
    }
}
